import { Link } from "react-router-dom";

export default function CartListTitle({ pagedata }) {
    return (
        <div className="heading flex-between">
            <h2>{pagedata.title}</h2>

            <Link to={'/'}>
                {pagedata.shopping_label}
                <img src="/images/partials/arrow-right.svg" alt="arrow-right" />
            </Link>
        </div>

    )
}
